import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Divider, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { useHandleNfse } from "../../hooks/useHandleNfse";

interface ModalCancelNfseProps {
	open: boolean;
	onClose: () => void;
	nfseId: string;
	documentGuid: string;
	refreshList: () => void;
	name?: string;
}

export function ModalCancelNfse({ open, onClose, nfseId, documentGuid, refreshList, name }: ModalCancelNfseProps) {
	const [reason, setReason] = useState("");
	const [touched, setTouched] = useState(false);

	const { handleCancelNfseByReason, isLoading } = useHandleNfse();

	const handleSubmit = () => {
		if (!reason.trim()) {
			setTouched(true);
			return;
		}

		handleCancelNfseByReason(nfseId, reason, documentGuid, () => {
			refreshList();
			onClose();
		});
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<Box display="flex" alignItems="center" justifyContent="space-between" pr={1}>
				<DialogTitle sx={{ pb: 1, color: "primary.main", fontWeight: "400" }}>Confirmar Cancelamento da NFSE</DialogTitle>
				<IconButton aria-label="fechar" onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</Box>
			<Divider />

			<DialogContent sx={{ pt: 2 }}>
				<Typography variant="body1" sx={{ mb: 1, fontWeight: 500 }}>
					{name}
				</Typography>
				<Typography variant="body2" sx={{ mb: 2 }}>
					Informe o motivo do cancelamento da nota fiscal:
				</Typography>

				<TextField
					label="Motivo do Cancelamento"
					value={reason}
					onChange={(e) => setReason(e.target.value)}
					onBlur={() => setTouched(true)}
					error={touched && !reason.trim()}
					helperText={touched && !reason.trim() ? "Motivo é obrigatório" : ""}
					fullWidth
					multiline
					minRows={3}
				/>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={onClose} disabled={isLoading}>
					Cancelar
				</Button>
				<Button onClick={handleSubmit} variant="contained" color="error" disabled={!reason.trim() || isLoading}>
					{isLoading ? "Cancelando..." : "Confirmar Cancelamento"}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
